import { CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAccidentsPerMonth,
  getAverageAttentionsNumber,
  getAverageTreatmentDays,
  getAvgAuthAnswerDaysPerQuarter,
  getCitationFrequenciesAverage,
  getPrevalenceRate,
  setStatisticsDashboardProvider,
} from "../../../actions/dashboard";
import { StyledStaticsContainer } from "../../styled/statics";
import StatisticDashboard from "./statisticDashboard";

const StatisticContainer = () => {
  const dispatch = useDispatch();

  const artIsFetching = useSelector((state) => state.art.isFetching);
  const selectedProvider = useSelector(
    (state) => state.providers.selectedProvider,
  );
  const statisticsProviderId = useSelector(
    (state) => state.dashboard.statisticsProviderId,
  );
  const accidentsPerMonth = useSelector(
    (state) => state.dashboard.accidentsPerMonth,
  );
  const citationFrequenciesAverage = useSelector(
    (state) => state.dashboard.citationFrequenciesAverage,
  );
  const averageTreatmentDays = useSelector(
    (state) => state.dashboard.averageTreatmentDays,
  );
  const avgAuthAnswerDaysPerQuarter = useSelector(
    (state) => state.dashboard.avgAuthAnswerDaysPerQuarter,
  );
  const prevalenceRate = useSelector((state) => state.dashboard.prevalenceRate);
  const averageAttentionsNumber = useSelector(
    (state) => state.dashboard.averageAttentionsNumber,
  );

  useEffect(() => {
    if (!selectedProvider) return;
    if (statisticsProviderId === selectedProvider) return;

    const isLoading =
      accidentsPerMonth.isFetching ||
      citationFrequenciesAverage.isFetching ||
      averageTreatmentDays.isFetching ||
      avgAuthAnswerDaysPerQuarter.isFetching ||
      prevalenceRate.isFetching ||
      averageAttentionsNumber.isFetching;
    if (isLoading) return;

    dispatch(setStatisticsDashboardProvider(selectedProvider));
    dispatch(getAccidentsPerMonth());
    dispatch(getAverageTreatmentDays());
    dispatch(getAvgAuthAnswerDaysPerQuarter());
    dispatch(getPrevalenceRate());
    dispatch(getAverageAttentionsNumber());
    dispatch(getCitationFrequenciesAverage());
  }, [dispatch, selectedProvider, statisticsProviderId]);

  return (
    <StyledStaticsContainer.Container>
      {artIsFetching ? (
        <StyledStaticsContainer.CircularLoadingContainer>
          <CircularProgress size={40} />
        </StyledStaticsContainer.CircularLoadingContainer>
      ) : (
        <StatisticDashboard />
      )}
    </StyledStaticsContainer.Container>
  );
};

export default StatisticContainer;
